import { render, staticRenderFns } from "./CategoriesMobile.vue?vue&type=template&id=53411686&"
import script from "./CategoriesMobile.vue?vue&type=script&lang=js&"
export * from "./CategoriesMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports